import { twMerge } from 'tailwind-merge'

interface OptionButtonProps {
  selected: boolean
  onClick: () => void
  children: React.ReactNode
}

export const OptionButton = ({ selected, onClick, children }: OptionButtonProps) => {
  return (
    <button
      className={twMerge(
        'hover:text-brand-primary text-text-primary main-transition-colors flex items-center justify-center rounded-lg px-5 py-2 text-[13px]',
        selected && 'bg-brand-primary/10',
      )}
      onClick={onClick}
    >
      {children}
    </button>
  )
}
